import * as Constants from "./constants"

export function isNotEmpty(data) {
    console.log('isNotEmpty data=', data)
    return data !== null && data !== undefined && data.trim() !== '';
}

export function isEmpty(data) {
    console.log('isEmpty data=', data)
    return data === null || data === undefined || data.trim() === '';
}

export function isPresentAuthenticatedUser() {
    const user = sessionStorage.getItem(Constants.USER_IN_SESSION);
    return user !== '' && user !== undefined && user !== 'undefined';
}

export function isUndefined(variable) {
    return variable === '' && variable === undefined && variable === 'undefined';
}

export function logout() {
    if (isPresentAuthenticatedUser()) {
        localStorage.clear();
        sessionStorage.clear();
        window.location.href = "/AGLogout";
    }
}

export function getUrlEsitoPagamento(authMode, esito) {
    if (esito === Constants.STR_ESITO_OK || esito === Constants.STR_ESITO_KO) {
        switch (authMode) {
            case Constants.AUTH_MODE_PUBLIC:
                return Constants.URL_ESITOPAGAMENTO_PUBLIC + esito;
            case Constants.AUTH_MODE_PROTECTED:
                return Constants.URL_ESITOPAGAMENTO_PROTECTED + esito;
            default:
                return "";
        }
    }
    return "";
}

export function getTipoProprietario(choiceRimborso) {
    switch (choiceRimborso) {
        case Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI:
        case Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI:
        case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
            return Constants.RIM_TIPO_PROPRIETARIO_POSSESSORE;
        case Constants.RIM_CHOICE_RIMBORSO_FUORIREGIONE:
            return Constants.RIM_TIPO_PROPRIETARIO_FUORI_REGIONE;
        case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
            return Constants.RIM_TIPO_PROPRIETARIO_INTERMEDIARIO;
        case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE_FUORIREGIONE:
            return Constants.RIM_TIPO_PROPRIETARIO_FUORI_REGIONE;
        default:
            return 'UNDEF';
    }
}

export function isRichiedenteDelegato(choiceRimborso) {
    switch (choiceRimborso) {
        case Constants.RIM_CHOICE_RIMBORSO_ELENCOVEICOLI:
        case Constants.RIM_CHOICE_RIMBORSO_CICLOMOTORI:
        case Constants.RIM_CHOICE_RIMBORSO_FUORIREGIONE:
            return false;
        case Constants.RIM_CHOICE_RIMBORSO_VEICOLOAZIENDALE:
        case Constants.RIM_CHOICE_RIMBORSO_INTERMEDIARI:
        default:
            return true;
    }
}

export function isCedutoOltreTreAnniFa(veic) {
    if (veic && veic.dataFineProprieta) {
        const annoDiInizioRicerca = new Date().getFullYear() - Constants.ULTIMI_TRE_ANNI;
        const token = veic.dataFineProprieta.split(Constants.SLASH);
        if (token && token.length === 3) {
            const annoCessioneVeicolo = parseInt(token[2]);
            return annoDiInizioRicerca > annoCessioneVeicolo;
        }
    }
    return false;
}

export function getTipoVeicoloLeggibile(tipoVeicolo) {
    switch (tipoVeicolo) {
        case Constants.TIPO_VEICOLO_CICLOMOTORE: return Constants.RADIO_LABEL_CICLOMOTORE;
        case Constants.TIPO_VEICOLO_QUADRICICLO_LEGGERO: return Constants.RADIO_LABEL_QUADRICICLO_LEGGERO;
        case Constants.TIPO_VEICOLO_TARGA_PROVA_AUTO: return Constants.RADIO_LABEL_TARGA_PROVA_AUTO;
        case Constants.TIPO_VEICOLO_TARGA_PROVA_MOTO: return Constants.RADIO_LABEL_TARGA_PROVA_MOTO;
        case Constants.TIPO_VEICOLO_TARGA_PROVA_CICLO: return Constants.RADIO_LABEL_TARGA_PROVA_CICLO;
        case Constants.TIPO_VEICOLO_TARGA_PROVA_RIMORCHIO: return Constants.RADIO_LABEL_TARGA_PROVA_RIMORCHIO;
        default: return Constants.RADIO_LABEL_ALTRI_CASI;
    }
}

export function getAltraCategoriaVeicoloLeggibile(_choice) {
    switch (_choice) {
        case Constants.ALTRI_CASI_VEICOLI_STORICI: return Constants.RADIO_LABEL_REIMM_VEICOLI_STORICI;
        case Constants.ALTRI_CASI_AFI: return Constants.RADIO_LABEL_ALTRI_CASI_AFI;
        case Constants.ALTRI_CASI_ESCURSIONISTI_ESTERI: return Constants.RADIO_LABEL_ALTRI_CASI_EE;
        case Constants.CRISI_FALLIMENTO: return Constants.RADIO_LABEL_CRISI_FALLIMENTO;
        case Constants.ALTRI_CASI_ALTRO: return Constants.RADIO_LABEL_ALTRI_CASI_ALTRO;
        default: return Constants.RADIO_LABEL_ALTRI_CASI_ALTRO;
    }
}
